export const SUPPORT_EMAIL = `support@bet25.dk`;
